import { render, staticRenderFns } from "./DeliveryTowerOnlyHere.vue?vue&type=template&id=49509225"
import script from "./DeliveryTowerOnlyHere.vue?vue&type=script&lang=js"
export * from "./DeliveryTowerOnlyHere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports